import { hole } from './api'
import type { BildErkennung } from './warteschlangen'

/**
 * Die Ortsdurchsicht — Spielplätze mit Bildern, zwanzig je Seite.
 *
 * Anders als die Warteschlangen wird hier nichts fällig: Die Liste ist ein
 * Bestand, kein Rückstau. Sie schrumpft nur, weil jemand hinsieht.
 */

/** Ein Bild des Ortes. `media_id` ist der Beleg, wenn ein Merkmal daher kommt. */
export interface Ortsbild extends BildErkennung {
  media_id: string
}

export interface Durchsichtsort {
  id: string
  name: string | null
  strasse: string | null
  plz: string | null
  stadt: string | null
  herkunft: string | null
  features: Record<string, unknown> | null
  accessibility: Record<string, unknown> | null
  merkmale: number
  fotos: number
  /** Wann zuletzt jemand hier entschieden hat, oder `null`. */
  durchgesehen_at: string | null
  bilder: Ortsbild[]
}

export interface Durchsichtsseite {
  gesamt: number
  offen: number
  seite: number
  seiten: number
  eintraege: Durchsichtsort[]
}

export const holeDurchsicht = (seite: number, nurOffene: boolean) =>
  hole<Durchsichtsseite>(
    `/api/ortsdurchsicht?seite=${seite}&offen=${nurOffene ? '1' : '0'}`,
  )

export const holeOrtsErkennung = (id: string) =>
  hole<{ bilder: Ortsbild[] }>(`/api/ortsdurchsicht/${id}/erkennung`)

export const ortsErkennungErneut = (id: string) =>
  hole<{ angestossen: boolean }>(`/api/ortsdurchsicht/${id}/erkennung`, {
    method: 'POST',
  })

/**
 * Durchgesehen — auch mit leerer Liste.
 *
 * **Das ist kein Sonderfall, sondern der häufige:** Bei einem Ort, an dem
 * schon siebzehn Merkmale stehen, ist „nichts zu ergänzen" die normale
 * Auskunft. Ohne sie käme der Ort beim nächsten Öffnen wieder.
 */
export const ortDurchgesehen = (id: string, merkmale: string[]) =>
  hole<{ id: string; merkmale: string[] }>(`/api/ortsdurchsicht/${id}`, {
    method: 'POST',
    body: JSON.stringify({ merkmale }),
  })
